import { createTheme } from "@material-ui/core/styles";
import Zoom from '@material-ui/core/Zoom';

const theme = createTheme({
    props: {
        MuiPopover: {
            TransitionComponent: Zoom
        }
    },
    overrides: {
        MuiMenuItem: { // For ListItem, change this to MuiListItem
            root: {
              "&$selected": {       // this is to refer to the prop provided by M-UI
                backgroundColor: "white", // updated backgroundColor
              },
            },
        },        
        MuiCssBaseline: {
            "@global": {
                "*, *::before, *::after": {
                    boxSizing: "border-box",
                },
                body: {
                    // backgroundColor: "#fff",
                    fontFamily: 'unset',
                    fontSize: 'unset',
                    fontWeight: 'unset',

                },
            },
        },
        MuiSpeedDialAction: {
            staticTooltipLabel: {},
        },
    },
    palette: {
        primary: {
            light: '#ff8e8c',
            main: '#2196F3',
            dark: '#5ba3dc',
            contrastText: '#fff',
        },
        secondary: {
            light: '#4da9b7',
            main: '#2C497F',
            dark: '#ffffff',
            contrastText: '#fff',
        },
    },
    typography: {
        textTransform: "none",
        fontFamily: "'Roboto', sans-serif"
    },
    button: {
        textTransform: "none",
        outline: "none",
    },
    default_button: {
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        padding: '7px 15px 6px',
        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '1em',
        cursor: 'pointer',
        outline: 'none',
        transition: 'all .3s ease',
        maxWidth: '100%',
        opacity: 1,
        lineHeight: 1,
        '&:hover': {
            opacity: .65
        }
    }
});

export default theme;
